import React, { useEffect, useState } from "react";
import axios from "axios";
import {
  FaTasks,
  FaHourglassHalf,
  FaSpinner,
  FaCheckCircle,
  FaClipboardCheck,
  FaClock,
} from "react-icons/fa"; // Importing icons
import "../style/dashboard.css"; // Import CSS for styling
import {
  PieChart,
  Pie,
  Cell,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";

const COLORS = ["#fd9696", "#FFA726", "#42A5F5", "#66BB6A", "#FF0000"];
const Dashboard = () => {
  const [dashboardData, setDashboardData] = useState({
    totalTasks: 0,
    pending: 0,
    ongoing: 0,
    inReview: 0,
    completed: 0,
    deadline: 0,
  });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const userData = JSON.parse(localStorage.getItem("user"));
  const userId = userData?.id;

  useEffect(() => {
    const fetchDashboardData = async () => {
      try {
        const response = await axios.get(
          `https://aligndesk.dropyourbusiness.com/api/dashboard/${userId}`
        );

        if (response.status === 200 && response.data) {
          console.log("Dashboard Data:", response.data); // Debugging API response

          const {
            task_status_counts = {},
            total_tasks = 0,
            deadline_count = 0,
          } = response.data;
          // Ensure that no error is set when response is valid
          setError(null);

          setDashboardData({
            totalTasks: total_tasks || 0,
            pending: task_status_counts.pending || 0,
            ongoing: task_status_counts.ongoing || 0,
            inReview: task_status_counts.inreview || 0,
            completed: task_status_counts.completed || 0,
            deadline: deadline_count || 0, // Adding Deadline Count
          });
        } else {
          setError("Invalid data received from API");
        }
      } catch (err) {
        console.error("API Error:", err);
        // setError("Failed to fetch dashboard data. Please try again.");
      } finally {
        setLoading(false);
      }
    };

    fetchDashboardData();
  }, [userId]);

  const pieData = [
    { name: "Pending", value: dashboardData.pending },
    { name: "Ongoing", value: dashboardData.ongoing },
    { name: "InReview", value: dashboardData.inReview },
    { name: "Completed", value: dashboardData.completed },
    { name: "Deadline", value: dashboardData.deadline },
  ];

  if (loading) return <p>Loading dashboard data...</p>;
  //Only show the error message if there's an actual API failure, not when tasks are 0
  if (error) return <p className="error">{error}</p>;
  const noTasks = Object.values(dashboardData).every((count) => count === 0);
  return (
    <div className="dashboard-main">
      <div className="dashboard">
        {/* {noTasks && <p className="no-tasks">No tasks assigned yet.</p>} */}
        <div className="card total">
          <div className="icon-bg">
            <FaTasks />
          </div>
          <div className="card-text">
            <h3>Total Tasks</h3>
            <p>{dashboardData.totalTasks}</p>
          </div>
        </div>
        <div className="card pending">
          <div className="icon-bg">
            <FaHourglassHalf />
          </div>
          <div className="card-text">
            <h3>Pending</h3>
            <p>{dashboardData.pending}</p>
          </div>
        </div>
        <div className="card ongoing">
          <div className="icon-bg">
            <FaSpinner />
          </div>
          <div className="card-text">
            <h3>Ongoing</h3>
            <p>{dashboardData.ongoing}</p>
          </div>
        </div>
        <div className="card in-review">
          <div className="icon-bg">
            <FaClipboardCheck />
          </div>
          <div className="card-text">
            <h3>InReview</h3>
            <p>{dashboardData.inReview}</p>
          </div>
        </div>
        <div className="card completed">
          <div className="icon-bg">
            <FaCheckCircle />
          </div>
          <div className="card-text">
            <h3>Completed</h3>
            <p>{dashboardData.completed}</p>
          </div>
        </div>
        <div className="card deadline">
          <div className="icon-bg">
            <FaClock />
          </div>
          <div className="card-text">
            <h3>Deadline</h3>
            <p>{dashboardData.deadline}</p>
          </div>
        </div>
      </div>
      <div className="chart-main-container">
        <div className="chart-container">
          <h3>Task Status Overview</h3>
          <ResponsiveContainer width="100%" height={300}>
            <PieChart>
              <Pie
                data={pieData}
                cx="50%"
                cy="50%"
                labelLine={false}
                outerRadius={100}
                fill="#8884d8"
                dataKey="value"
                label={({ name, percent }) =>
                  `${name} ${(percent * 100).toFixed(0)}%`
                }
              >
                {pieData.map((entry, index) => (
                  <Cell
                    key={`cell-${index}`}
                    fill={COLORS[index % COLORS.length]}
                  />
                ))}
              </Pie>
              <Tooltip />
              <Legend />
            </PieChart>
          </ResponsiveContainer>
        </div>
      </div>
    </div>
  );
};
export default Dashboard;
